import { useState } from "react";
import clsx from "clsx";
import dayjs from "dayjs";

import Stepper from "components/Stepper";
import { STEP_LIST } from "constants/signup";
import AuthLayout from "layouts/Auth";
import type { SignUpFormUser, SignUpUserFormData } from "models/User";
import UserSection from "./modules/UserSection";
import BusinessSection from "./modules/BusinessSection";
import ConfirmSection from "./modules/ConfirmSection";

interface ISectionProps {
  step: number;
  setFormDataCallback: (data: SignUpFormUser) => void;
  setStepCallback: (step: number) => void;
  basicFormData?: SignUpUserFormData;
}

function SelectedSection({
  step,
  setFormDataCallback,
  setStepCallback,
  basicFormData
}: Readonly<ISectionProps>) {
  switch (step) {
    case 0:
      return (
        <UserSection
          basicFormData={basicFormData}
          setFormDataCallback={setFormDataCallback}
          setStepCallback={setStepCallback}
        />
      );

    case 1:
      return <BusinessSection basicFormData={basicFormData} setStepCallback={setStepCallback} />;

    case 2:
      return <ConfirmSection basicFormData={basicFormData} />;

    default:
      return null;
  }
}

export default function SignUp() {
  const [basicFormData, setBasicFormData] = useState<SignUpFormUser>();
  const [step, setStep] = useState(0);
  const currentYear = dayjs().year();

  const setFormDataCallback = (data: SignUpFormUser, isValid?: boolean) => {
    if (isValid) setBasicFormData(data);
  };

  return (
    <AuthLayout
      size="lg"
      headerClass="desktop:!gap-8 desktop:!pt-14"
      header={
        <Stepper
          data={STEP_LIST}
          currentStep={step}
          setStep={setStep}
          className={clsx("z-20 mobile:pb-5", step === 0 && "mobile:!hidden")}
        />
      }>
      <SelectedSection
        basicFormData={basicFormData}
        setFormDataCallback={setFormDataCallback}
        setStepCallback={setStep}
        step={step}
      />

      <p
        className={clsx(
          "mx-auto text-xs font-light text-subtitle desktop:hidden",
          step === 0 ? "mt-auto" : "mt-5"
        )}>
        &copy; {currentYear} HaulPay | All Rights Reserved
      </p>
    </AuthLayout>
  );
}
